import React, { useState } from 'react';
import {
  MDBContainer,
  MDBBtn,
  MDBInput,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';
import Header from './components/header';
import Footer from './components/footer';
import { useNavigate } from "react-router-dom";
import RegisterCliente from './api/registerCliente';
import LoginCliente from './api/loginCliente';
import Cookies from 'universal-cookie';

function Register() {
  const navigate = useNavigate();
  const cookies = new Cookies();

  // Estados simplificados
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");

  // Manejo de inicio de sesión automático tras registro
  async function handleSignIn() {
    try {
      // 1. Llamamos al login con los datos que acabamos de registrar
      const response = await LoginCliente(email, password);
      
      // 2. IMPORTANTE: En Passport/Express la respuesta suele venir directo en 'response' 
      // o 'response.data'. Si usas axios, es response.data.
      const data = response.data || response; 

      if (data.auth) {
        // Guardamos en localStorage igual que en el componente Login
        localStorage.setItem('user', JSON.stringify(data.user));
        
        // Navegación directa
        const tipo = data.user.Tipo || data.user.tipo;
        const target = tipo === 'a' ? '/agendaAdmin' : '/agenda';
        
        // Si usas HashRouter:
        window.location.hash = target;
      } else {
        alert("Registro exitoso, pero no se pudo iniciar sesión automáticamente.");
      }
    } catch (error) {
      console.error("Error en sign-in automático:", error);
      alert("Error al conectar para el inicio automático.");
    }
  }

  const [loading, setLoading] = useState(false);

  const handleSignUp = async () => {
    // 1. Validación de contraseñas (lado del cliente)
    if (password !== passwordRepeat) {
      alert("Las contraseñas no coinciden.");
      return;
    }

    // 2. Validación de campos vacíos
    // Usamos trim() para que no nos engañen con puros espacios
    if (!nombre.trim() || !apellido.trim() || !email.trim() || !tel.trim() || !password) {
      alert("Debe llenar todos los campos.");
      return;
    }

    try {
      setLoading(true);

      // 3. Ejecutar el Registro
      // Mandamos los datos tal cual los espera tu controlador de Node
      const response = await RegisterCliente(
        nombre.trim(),
        apellido.trim(),
        email.trim().toLowerCase(), // Normalizamos el mail a minúsculas
        tel.trim(),
        password
      );

      if (response.success) {
        console.log("Registro exitoso. ID asignado:", response.userId);
        
        // 4. Login Automático
        // Importante: handleSignIn debe usar 'email' y 'password' de los estados
        await handleSignIn(); 
        
        // La navegación se maneja dentro de handleSignIn al verificar el tipo de usuario
      } else {
        // Aquí el backend nos avisa si el mail ya existe (Error 409)
        alert(response.message || "Error al registrar el usuario.");
      }

    } catch (error) {
      console.error("Error en el flujo de registro:", error);
      alert("No se pudo conectar con el servidor. Revisa tu conexión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header active="Registrarme"></Header>
      <MDBContainer className="p-4 my-5 shadow-5 rounded-6 bg-white" style={{ maxWidth: '700px' }}>
        
        <div className="text-center mb-5">
          <h1 className="fw-bold display-5 mb-3" style={{ color: '#2c3e50' }}>
            Únete a Veterinaria Ladradoc
          </h1>
          <h4 className="text-muted">Crea tu cuenta en pocos pasos para agendar tus consultas.</h4>
          <hr className="hr hr-blurry w-25 mx-auto" />
        </div>

        <MDBRow>
          <MDBCol md="6">
            <MDBInput 
              onChange={(e) => setNombre(e.target.value)} 
              value={nombre} 
              wrapperClass='mb-4' 
              label='Nombre' 
              type='text'
            />
          </MDBCol>
          <MDBCol md="6">
            <MDBInput 
              onChange={(e) => setApellido(e.target.value)} 
              value={apellido} 
              wrapperClass='mb-4' 
              label='Apellido' 
              type='text'
            />
          </MDBCol>

          <MDBCol md="6">
            <MDBInput 
              onChange={(e) => setEmail(e.target.value)} 
              value={email} 
              wrapperClass='mb-4' 
              label='Correo electrónico' 
              type='email'
            />
          </MDBCol>
          <MDBCol md="6">
            <MDBInput 
              onChange={(e) => setTel(e.target.value)} 
              value={tel} 
              wrapperClass='mb-4' 
              label='Teléfono' 
              type='text'
            />
          </MDBCol>

          <MDBCol md="6">
            <MDBInput 
              onChange={(e) => setPassword(e.target.value)} 
              value={password} 
              wrapperClass='mb-4' 
              label='Contraseña' 
              type='password'
            />
          </MDBCol>
          <MDBCol md="6">
            <MDBInput 
              onChange={(e) => setPasswordRepeat(e.target.value)} 
              value={passwordRepeat} 
              wrapperClass='mb-4' 
              label='Repetir Contraseña' 
              type='password'
            />
          </MDBCol>
        </MDBRow>
      
        <MDBRow className="mb-4 mt-4 d-flex justify-content-center">
  
  {/* Botón Registrar */}
  <MDBCol md="5" className="mb-3 mb-md-0 d-flex justify-content-center">
    <MDBBtn 
      onClick={handleSignUp} 
      className="btn-lg shadow-0 text-white w-100" 
      style={{ 
        backgroundColor: '#1266f1', 
        height: '50px',
        maxWidth: '250px' // Ancho máximo fijo
      }}
    >
      Registrar
    </MDBBtn>
  </MDBCol>
  
  {/* Botón Login (Outline) */}
  <MDBCol md="5" className="d-flex justify-content-center">
    <MDBBtn 
      onClick={() => navigate('/login')} 
      outline 
      color='primary' 
      className="btn-lg shadow-0 w-100"
      style={{ 
        height: '50px', // Misma altura
        maxWidth: '250px' // Mismo ancho máximo
      }}
    >
      Ya tengo cuenta
    </MDBBtn>
  </MDBCol>

</MDBRow>

      </MDBContainer>
      <Footer />
    </>
  );
}

export default Register;